// Kraje szczytów: kody ISO 3166-1 alpha-2 (BE: peak_countries) i polskie nazwy z Intl
export const COUNTRY_CODES = [
  'PL', 'SK', 'CZ', 'UA', 'DE', 'AT', 'CH', 'IT', 'FR', 'ES', 'PT', 'AD', 'SI', 'HR', 'BA', 'RS', 'ME', 'AL', 'MK', 'GR',
  'BG', 'RO', 'HU', 'LT', 'LV', 'EE', 'BY', 'NO', 'SE', 'FI', 'IS', 'GB', 'IE', 'GE', 'AM', 'TR', 'RU', 'MA', 'TZ', 'KE',
  'NP', 'CN', 'IN', 'PK', 'JP', 'US', 'CA', 'MX', 'AR', 'CL', 'PE', 'BO', 'EC', 'NZ', 'AU'
]

export const COUNTRY_FORMS = ['kraj', 'kraje', 'krajów']

const countryNames = typeof Intl !== 'undefined' && Intl.DisplayNames ? new Intl.DisplayNames(['pl'], { type: 'region' }) : null

export function countryName(code) {
  try {
    return (countryNames && countryNames.of(code)) || code
  } catch (err) {
    return code
  }
}
